//
//
//
//
//
//

export default {
    props: {
        isClient: {
            type: Boolean,
            required: true,
        },
        size: {
            type: Number,
            default: 4,
        },
    },
    computed: {
        classes() {
            const size = `col-${this.size} col-centered-${this.size} margin-bottom-0`;
            const stylesWeb = 'wrapper-custom-bg padding-2 padding-left-sm-max-1 padding-right-sm-max-1 padding-top-sm-max-1 padding-bottom-sm-max-1';
            const stylesMobile = 'padding-0';

            return [
                size,
                this.isClient ? stylesMobile : stylesWeb,
            ].join(' ');
        },
    },
};
